import { Spinner } from '@chopchop-se/ui';
import type { ReactNode } from 'react';

/** Full-viewport loading state — session bootstrap and lazy route chunks. */
export function FullPageSpinner({ label }: { label?: string }): ReactNode {
  return (
    <div className="flex min-h-[60vh] w-full flex-col items-center justify-center gap-3" role="status" aria-live="polite">
      <Spinner className="size-6 text-brand-600" />
      {label ? <p className="text-sm text-ink-muted">{label}</p> : null}
    </div>
  );
}
